import React from 'react';
import { config } from '@app/config';
import { useSelector } from 'react-redux';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import WrapperScroll from '../../WrapperScroll/WrapperScroll';
import styles from '../styles.module.scss';
import ToolItem from './ToolItem';
const SHORTCUTS = [{
  type: 'ats',
  text: '👩🏻‍💼 Quản lý ứng viên',
  sub_text: '🔒 Kích hoạt ngay',
  text_color: '#222222',
  sub_text_color: '#306BD9',
  background: '#F2F6FC',
  web_url: `${config.jobURL}/nha-tuyen-dung/quan-ly-ung-vien`,
  isNew: false
}, {
  type: 'jsdb',
  text: '🔍 Tìm ứng viên mới',
  sub_text: '🔍 Tìm ứng viên mới',
  text_color: '#222222',
  sub_text_color: '#FF8800',
  background: '#FFF4E0',
  web_url: `${config.jobURL}/nha-tuyen-dung/tim-ung-vien`,
  isNew: false
}, {
  type: 'partner',
  text: 'Trở thành Đối Tác',
  sub_text: 'Xem ngay',
  text_color: '#FFFFFF',
  sub_text_color: '#FFFFFF',
  background: 'https://static.chotot.com/storage/JOB_STATIC_CDN/shortcut_partner_background.svg',
  app_background: 'https://static.chotot.com/storage/JOB_STATIC_CDN/shortcut_partner_background_msite.svg',
  web_url: `${config.jobURL}/kinh-nghiem/uu-dai-cho-doi-tac-tuyen-dung.html`,
  isNew: false
}, {
  type: 'pro',
  text: 'Gói tuyển dụng',
  sub_text: 'Khám phá ngay',
  text_color: '#FFFFFF',
  sub_text_color: '#FFFFFF',
  background: 'https://static.chotot.com/storage/JOB_STATIC_CDN/pro_subscription.svg',
  app_background: 'https://static.chotot.com/storage/JOB_STATIC_CDN/pro_subscription_msite.svg',
  web_url: 'https://www.chotot.com/goi-pro/viec-lam',
  isNew: false
}];
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "wiwbxky"
});
const LinearBackground = /*#__PURE__*/styled("div")({
  name: "LinearBackground",
  class: "l10tgvzm"
});
const Grid = /*#__PURE__*/styled("div")({
  name: "Grid",
  class: "g1xucnut"
});
const Tools = ({
  isMobile,
  data: {
    totalJsdb,
    totalCandidateAts,
    isLoadedTotalCandidateAts,
    totalAdsByUser,
    isLoadedTotalJsdb,
    isLoadedTotalAdsByUser
  },
  onClickShortcut
}) => {
  const auth = useSelector(state => state.auth);
  const getSubText = item => {
    const {
      type,
      sub_text: subText
    } = item;
    let tmpSubText = subText;
    if (type === 'ats' && auth?.authenticated && isLoadedTotalCandidateAts && isLoadedTotalAdsByUser) {
      tmpSubText = totalAdsByUser === 0 ? 'Chưa có tin đăng' : `${totalCandidateAts} hồ sơ mới`;
    }
    if (type === 'jsdb') {
      tmpSubText = `${totalJsdb} ứng viên`;
    }
    return tmpSubText;
  };
  return <Wrapper>
      {isLoadedTotalCandidateAts || isLoadedTotalJsdb ? <WrapperScroll cols={SHORTCUTS.length} total={SHORTCUTS.length} mobile={{
      cols: 2.5
    }} isEquallyDivided isMobile={isMobile} className={styles.oneRowContent} noPadding>
          <div className="row-cat">
            {SHORTCUTS.map((item, index) => {
          const subText = getSubText(item);
          return <ToolItem key={`${item.type} - ${index.toString()}`} background={item.background} subTextColor={item.sub_text_color} textColor={item.text_color} mainText={item.text} subText={subText} url={item.web_url} type={item.type} onClickShortcut={onClickShortcut} appBackground={item.app_background} isMobile={isMobile} />;
        })}
          </div>
        </WrapperScroll> : <Grid>
          <LinearBackground key="LinearBackgroundTool1">
            <div className="linearImg" />
          </LinearBackground>
          <LinearBackground key="LinearBackgroundTool2">
            <div className="linearImg" />
          </LinearBackground>
          <LinearBackground key="LinearBackgroundTool3">
            <div className="linearImg" />
          </LinearBackground>
          <LinearBackground key="LinearBackgroundTool4">
            <div className="linearImg" />
          </LinearBackground>
        </Grid>}
    </Wrapper>;
};
export default Tools;

require("../../../../.linaria-cache/src/components/RecruitmentHub/Tool/Tool.linaria.module.css");